import zoid from 'zoid';
import { decodeObject, encodeObject } from './utils/encoding';

// This script is modified from: https://gitlab.flywire.tech/flywire/development/flywire-payex/-/blob/master/src/EmbeddedEntry.js
// To allow embedding the payex tracking page directly
if (document.getElementById('fw-payex-tracking-entry')) {
  const selector = '.PayexTrackingEntry';

  const orderId = document.getElementById('fw-order-id').value;
  const orderToken = document.getElementById('fw-order-token').value;
  const apiBaseUrl = document.getElementById('fw-api-base-url').value;
  const cspNonce = document.getElementById('fw-csp-nonce')?.value;

  const embeddedTracking = zoid.create({
    // For some reason, this needs to match a tag defined in flywire-payex: https://gitlab.flywire.tech/flywire/development/flywire-payex/-/blob/master/src/EmbeddedEntry.js#L6
    tag: 'fw-payment',
    dimensions: {
      width: '100%',
      height: '98vh'
    },
    url: config => {
      // cspNonce is the one prop passed through unencoded, so it must be kept out
      // of decodeObject — base64-decoding a random nonce throws a URIError.
      const {cspNonce, ...encodedProps} = config.props;
      const props = decodeObject(encodedProps);

      const protocol = props.apiBaseUrl.endsWith('test') ? 'http' : 'https'

      return `${protocol}://${props.apiBaseUrl}/tracking/${props.orderId}?token=${props.orderToken}`;
    },
    scrolling: true,
    defaultLogLevel: 'error',
    props: {
      // zoid's built-in cspNonce is the only prop it forwards to the child. The
      // nonce is only meaningful in this document, and flywire-payex base64-decodes
      // every prop it receives, so forwarding it there throws a URIError.
      cspNonce: {
        type: 'string',
        required: false,
        sendToChild: false
      }
    }
  });

  const embeddedTrackingAdapter = {
    Tracking: {
      render: (config, selector) => {
        const encodedConfig = encodeObject(config);

        // zoid reads `cspNonce` as a plain string to nonce the <style> elements it
        // creates, so it has to be added after encodeObject base64s every value.
        return embeddedTracking({...encodedConfig, cspNonce}).render(selector);
      }
    }
  };

  const paymentData = {
    apiBaseUrl,
    orderId,
    orderToken
  };

  embeddedTrackingAdapter.Tracking.render(paymentData, selector);
}
